import * as React from 'react';
import { IconProps } from '../types';

const IcFunctionGiftCardFill = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
     <path
      fill={props?.fill ?? '#232F3E'}
      d="M5.162 3.38c.658-1.333 2.536-1.834 3.741-.957.751.58 1.424 1.255 2.113 1.897.391-.282.814-.595 1.33-.611.61-.078 1.19.22 1.628.611.689-.595 1.346-1.254 2.05-1.834 1.018-.8 2.583-.611 3.428.345.767.815.877 2.1.33 3.057.563 0 1.11-.031 1.674.016.563.078.986.58 1.08 1.128v2.289c-.141.298-.423.533-.767.486h-18.5c-.345.047-.627-.188-.767-.486V7.032c.094-.548.516-1.066 1.08-1.128.547-.063 1.11-.016 1.659-.016-.439-.768-.486-1.74-.079-2.508Zm1.096.784c-.266.736.282 1.63 1.08 1.677.83.047 1.675 0 2.504.016.266-.032.595.094.783-.142-.767-.752-1.565-1.457-2.38-2.179-.641-.533-1.752-.172-1.987.628Zm10.236-.392c-.673.642-1.408 1.222-2.05 1.912l.015.173c1.018 0 2.035.015 3.068 0 .501-.016 1.002-.33 1.19-.8.266-.596-.016-1.364-.626-1.646-.533-.282-1.19-.047-1.597.36ZM3.8 11.108h7.404v10.926h-.047c-2.05-.062-4.085.016-6.136-.031-.688-.016-1.252-.674-1.205-1.364-.031-3.182-.015-6.364-.015-9.531ZM13.802 11.108h7.403v9.531c.047.674-.516 1.333-1.205 1.364-2.05.047-4.085-.016-6.135.031h-.063c0-3.652.016-7.29 0-10.926Z"
    />
  </svg>
);

export default IcFunctionGiftCardFill;
